export default {
    openAlgorithmByIdAsync: async ({ dispatch, state, rootGetters }, { tree, treeLoaded = false }) => {
        if (!treeLoaded) {
            if (!state.lastItemId || rootGetters['topics/item'].id != state.lastItemId) {
                state.lastItemId = rootGetters['topics/item'].id;
                state.inputs = {};
            }
            await dispatch('addNode', { level: 0, ...JSON.parse(tree) });
        }
    },
    sliceNodes: async ({ state }, level) => {
        state.nodes = state.nodes.slice(0, level);
    },
    addNode: async ({ state, dispatch }, node) => {
        if (!!node) {
            if (typeof node.level !== 'number') {
                throw new Error();
            }
            await dispatch('sliceNodes', node.level);
            state.nodes.push(node);
        }
    }
}






